import { ReactElement, ReactNode } from 'react';
import { DeviceType, ParametersType, PriorityList } from '../constants/telosair-interfaces';
import { getPriorityColor } from '../_helpers/dashboardHelper';
import { useData } from '../context/data.context';
import { getCSSClassBasedOnPriority } from '../_helpers/globalHelper';

type CustomParameterBgProps = {
  parameterKey: ParametersType;
  parameterValue: number | null;
  children?: ReactNode;
  className?: string;
  type: DeviceType;
};

/**
 * React component to get custom background accourding to paramater and value.
 * @param props - Properties of CustomParameterBg.
 * @returns - Reactcomponent for CustomParameterBg.
 */
export default function CustomParameterBg(props: CustomParameterBgProps): ReactElement {
  const { clientThresholdSettings, userConfigDataV2 } = useData();
  const { children, parameterKey, parameterValue, className, type } = props;

  let priority: PriorityList = PriorityList.none;
  if (parameterValue !== undefined && parameterValue !== null) {
    priority = getPriorityColor(
      parameterKey,
      parameterValue,
      clientThresholdSettings,
      userConfigDataV2,
      type
    );
  }

  return (
    <div className={`${getCSSClassBasedOnPriority(priority, 'background')} ${className}`}>
      {children}
    </div>
  );
}
